var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/hrgs/master/UserEnum';
import ApiService from '@/core/services/ApiService';
import { ElMessage } from 'element-plus';
import { IUserPositionForm } from '@/core/types/entities/hrgs/master/UserEntities';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
import { Pagination } from '@/core/enums/Pagination';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/users`
};
let UserModule = class UserModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.userList = [];
        this.loading = false;
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1
        };
        this.userPositionList = [];
        this.loadingUserPosition = false;
        this.paginationUserPosition = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1
        };
        this.filterUserPosition = {
            nik: '',
            positionId: ''
        };
        this.orderBy = null;
        this.userGroupList = [];
    }
    // *GETTERS
    get getUserList() {
        return this.userList;
    }
    get getUserListLoading() {
        return this.loading;
    }
    get getUserListPagination() {
        return this.pagination;
    }
    get getUserPositionList() {
        return this.userPositionList;
    }
    get getUserPositionListLoading() {
        return this.loadingUserPosition;
    }
    get getUserPositionListFilter() {
        return this.filterUserPosition;
    }
    get getUserPositionListPagination() {
        return this.paginationUserPosition;
    }
    get getUserGroupList() {
        return this.userGroupList;
    }
    // *MUTATIONS
    [_a = Mutations.SET_USER_LIST](data) {
        this.userList = data;
    }
    [_b = Mutations.SET_USER_LIST_LOADING](data) {
        this.loading = data;
    }
    [_c = Mutations.SET_USER_LIST_PAGINATION](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize)
        };
    }
    [_d = Mutations.SET_USER_POSITION_LIST](data) {
        this.userPositionList = data;
    }
    [_e = Mutations.SET_USER_POSITION_LIST_LOADING](data) {
        this.loadingUserPosition = data;
    }
    [_f = Mutations.SET_USER_POSITION_LIST_FILTER](data) {
        this.filterUserPosition = Object.assign(Object.assign({}, this.filterUserPosition), data);
    }
    [_g = Mutations.RESET_USER_POSITION_LIST_FILTER]() {
        this.filterUserPosition = {
            nik: '',
            positionId: ''
        };
    }
    [_h = Mutations.SET_ORDER](data) {
        this.orderBy = data;
    }
    [_j = Mutations.SET_USER_POSITION_LIST_PAGINATION](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.paginationUserPosition.totalPageSize;
        const currentPage = data.currentPage || this.paginationUserPosition.currentPage;
        this.paginationUserPosition = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize)
        };
    }
    [_k = Mutations.SET_USER_GROUP_LIST](data = []) {
        this.userGroupList = data;
    }
    // *start: ACTION
    [_l = Actions.GET_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            Search: (payload === null || payload === void 0 ? void 0 : payload.search) || '',
            pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE,
            pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO
        };
        this.context.commit(Mutations.SET_USER_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}?&${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_USER_LIST, resData);
                this.context.commit(Mutations.SET_USER_LIST_PAGINATION, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: response.data.result.totalItems
                });
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_USER_LIST_LOADING, false);
            });
        });
    }
    [_m = Actions.GET_DETAIL](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const data = response.data.result.content;
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_o = Actions.UPDATE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload.data;
        return new Promise((resolve, reject) => {
            ApiService.put(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                reject(_response);
            });
        });
    }
    [_p = Actions.DELETE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    reject();
                }
                this.context.dispatch(Actions.GET_LIST);
                resolve(res.data.statusCode);
            })
                .catch((response) => {
                reject(response);
            });
        });
    }
    [_q = Actions.GET_USER_GROUP]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        this.context.commit(Mutations.SET_USER_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/groups?&${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_USER_GROUP_LIST, resData);
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    // position mapping
    [_r = Actions.GET_USER_POSITION_LIST](payload) {
        var _3, _4;
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const filter = `SearchValues=${((_3 = this.filterUserPosition) === null || _3 === void 0 ? void 0 : _3.nik) || ''}&SearchValues=${((_4 = this.filterUserPosition) === null || _4 === void 0 ? void 0 : _4.positionId) || ''}`;
        const params = Object.assign({ ver: 'v1', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO }, (this.orderBy && {
            orderBy: this.orderBy
        }));
        this.context.commit(Mutations.SET_USER_POSITION_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/positions?${new URLSearchParams(params).toString()}&${filter}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_USER_POSITION_LIST, resData.data);
                this.context.commit(Mutations.SET_USER_POSITION_LIST_PAGINATION, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: resData.totalRecords
                });
                resolve(resData.data);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get position mapping list.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_USER_POSITION_LIST_LOADING, false);
            });
        });
    }
    [_s = Actions.POST_USER_POSITION_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload;
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/${payload.userId}/positions?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    this.context.commit(Mutations.RESET_USER_POSITION_LIST_FILTER);
                    this.context.dispatch(Actions.GET_USER_POSITION_LIST);
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed create position mapping.'
                });
                reject(_response);
            });
        });
    }
    [_t = Actions.UPDATE_USER_POSITION_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload.data;
        return new Promise((resolve, reject) => {
            ApiService.put(`${API_URLS.url}/${employeeID}/${payload.userId}/positions?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    this.context.commit(Mutations.RESET_USER_POSITION_LIST_FILTER);
                    this.context.dispatch(Actions.GET_USER_POSITION_LIST);
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed update position mapping.'
                });
                reject(_response);
            });
        });
    }
    [_u = Actions.DELETE_USER_POSITION_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API_URLS.url}/${employeeID}/${payload.id}/positions?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else {
                    this.context.commit(Mutations.RESET_USER_POSITION_LIST_FILTER);
                    this.context.dispatch(Actions.GET_USER_POSITION_LIST);
                    resolve(res.data.statusCode);
                }
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed delete position mapping.'
                });
                reject(error);
            });
        });
    }
    [_v = Actions.CREATE_EXPORT_USER_POSITION]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/positionmapping/exportcreate?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_w = Actions.CHANGE_EXPORT_USER_POSITION]() {
        var _3, _4;
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const filter = `SearchValues=${((_3 = this.filterUserPosition) === null || _3 === void 0 ? void 0 : _3.nik) || ''}&SearchValues=${((_4 = this.filterUserPosition) === null || _4 === void 0 ? void 0 : _4.positionId) || ''}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/positionmapping/exportchange?${filter}&${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_x = Actions.DOWNLOAD_USER_POSITION](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            fileName: (payload === null || payload === void 0 ? void 0 : payload.fileName) || ''
        };
        return new Promise((resolve, reject) => {
            ApiService.getBlob(`${API_URLS.url}/${employeeID}/positionmapping/download?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.fileName);
                document.body.appendChild(link);
                link.click();
                resolve();
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_y = Actions.UPLOAD_CHANGE_USER_POSITION](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = new FormData();
        formdata.append('fileUpload', payload.fileUpload);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/positionmapping/changeupload?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed upload change position mapping.'
                });
                reject(_response);
            });
        });
    }
    [_z = Actions.UPLOAD_SUBMIT_CHANGE_USER_POSITION](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            request: payload.data
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/positionmapping/changeupload/submit?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed submit upload change position mapping.'
                });
                reject(_response);
            });
        });
    }
    [_0 = Actions.UPLOAD_CREATE_USER_POSITION](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = new FormData();
        formdata.append('fileUpload', payload.fileUpload);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/positionmapping/createupload?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed upload create position mapping.'
                });
                reject(_response);
            });
        });
    }
    [_1 = Actions.UPLOAD_SUBMIT_CREATE_USER_POSITION](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            request: payload.data
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/positionmapping/createupload/submit?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed submit upload create position mapping.'
                });
                reject(_response);
            });
        });
    }
    [_2 = Actions.GET_USER_POSITION]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/${employeeID}/positions?&${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result;
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get position mapping'
                });
                reject(error);
            })
                .finally(() => {
                //
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _k, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _l, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _m, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _o, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _p, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _q, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _r, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_3 = typeof IUserPositionForm !== "undefined" && IUserPositionForm) === "function" ? _3 : Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _s, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _t, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _u, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _v, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _w, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _x, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _y, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _z, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _0, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _1, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserModule.prototype, _2, null);
UserModule = __decorate([
    Module
], UserModule);
export default UserModule;
